import styled from 'styled-components';

export const Line = styled.div`
  background-color: #D02B48;
  height: 3px;
  width: 100%;
`;
